module.exports = __webpack_public_path__ + "img/homepage_phone.9c32da5a.png";